"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_redux_1 = require("react-redux");
var index_1 = require("../../actions/index");
var GridFilterWrapperComponent_1 = __importDefault(require("./GridFilterWrapperComponent"));
var mapDispatchForWrapper = function (dispatch, _a) {
    var grid = _a.grid, initialValues = _a.initialValues;
    return ({
        initializeFilter: function () { return dispatch((0, index_1.initializeFilter)(grid, initialValues)); }
    });
};
// @ts-ignore
var GridFilterWrapperContainer = (0, react_redux_1.connect)(null, mapDispatchForWrapper)(GridFilterWrapperComponent_1["default"]);
exports["default"] = GridFilterWrapperContainer;
